import React, { useState } from 'react';
import { 
  Box, 
  Typography, 
  TextField, 
  Button, 
  Paper,
  InputAdornment,
  IconButton,
  Tooltip
} from '@mui/material';
import YouTubeIcon from '@mui/icons-material/YouTube';
import InfoIcon from '@mui/icons-material/Info';
import PreviewIcon from '@mui/icons-material/Preview';

const YouTubePlaylistConfig = ({ config, onChange }) => {
  const [playlistId, setPlaylistId] = useState(config.playlistId || '');
  const [previewOpen, setPreviewOpen] = useState(false);

  const handleChange = (e) => {
    setPlaylistId(e.target.value);
  };

  const handleSave = () => {
    onChange({ playlistId });
  };

  // Auxiliar para extrair ID da playlist de uma URL
  const handleExtractFromUrl = () => {
    try {
      const url = playlistId;
      if (url.includes('list=')) {
        const matches = url.match(/list=([^&]+)/);
        if (matches && matches[1]) {
          setPlaylistId(matches[1]);
        }
      }
    } catch (error) {
      console.error('Erro ao extrair ID da playlist:', error);
    }
  };

  const togglePreview = () => {
    setPreviewOpen(!previewOpen);
  };

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Playlist do YouTube
      </Typography>
      <Typography variant="body2" color="text.secondary" paragraph>
        Configure a playlist de vídeos que será exibida no painel de chamada.
      </Typography>
      
      <Box sx={{ mt: 2, maxWidth: 600 }}>
        <TextField
          fullWidth
          label="ID da Playlist ou URL"
          variant="outlined"
          value={playlistId}
          onChange={handleChange}
          placeholder="Ex: PLRDNddkJ9BTDGn6IpkvFewfv3cnWlOJlP"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <YouTubeIcon color="error" />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <Tooltip title="Extrair ID da playlist a partir da URL">
                  <IconButton
                    aria-label="extrair ID da playlist"
                    onClick={handleExtractFromUrl}
                    edge="end"
                  >
                    <InfoIcon />
                  </IconButton>
                </Tooltip>
              </InputAdornment>
            )
          }}
        />
        
        <Box sx={{ mt: 2, display: 'flex', gap: 2 }}>
          <Button 
            variant="contained" 
            onClick={handleSave}
          >
            Aplicar
          </Button>
          <Button 
            variant="outlined" 
            startIcon={<PreviewIcon />}
            onClick={togglePreview}
          >
            {previewOpen ? 'Ocultar Prévia' : 'Mostrar Prévia'}
          </Button>
        </Box>
        
        {previewOpen && playlistId && (
          <Paper elevation={2} sx={{ mt: 3, p: 2, borderRadius: 2, bgcolor: '#f5f5f5' }}>
            <Typography variant="subtitle2" gutterBottom>
              Prévia da Playlist:
            </Typography>
            <Box sx={{ 
              position: 'relative',
              paddingTop: '56.25%', // 16:9 Aspect Ratio
              mt: 1,
              overflow: 'hidden',
              borderRadius: 1
            }}>
              <iframe
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  border: 'none'
                }}
                src={`https://www.youtube.com/embed/videoseries?list=${playlistId}`}
                title="Prévia da Playlist"
                allowFullScreen
              />
            </Box>
          </Paper>
        )}
      </Box>
    </Box>
  );
};

export default YouTubePlaylistConfig; 